import React from 'react'
import {useState,useEffect} from 'react'
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import img from '../Images/indiaa.jpg'
const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
});
const Regional = () => {
  const classes = useStyles();
    const url = 'https://api.rootnet.in/covid19-in/stats/latest'

    const [data, setData] = useState([])
  
    useEffect(() => {
    
      fetch(url)
      .then(response => response.json())
      .then(data => setData(data.data.regional));
      
    }, [])
  
    const renderTable = () => {
      return data.map(data => {
        return (
     
          <TableRow>
          <TableCell align="left">{data.loc}</TableCell>
          <TableCell align="right">{data.totalConfirmed}</TableCell>
          <TableCell align="right">{data.discharged}</TableCell>
          <TableCell align="right">{data.deaths}</TableCell>
  
          </TableRow>
        )
      })
    }
    return (
        <div className="p-5">
            <h2 className="text-center mb-5">India: Regional COVID Updates</h2>
            <img src={img} alt="hospital" className="mx-auto img-fluid  d-block" />
            <TableContainer component={Paper}>
      <Table className={classes.table} aria-label="simple table">
        <TableHead>
          <TableRow>  
          <TableCell align="left"><h4>Country</h4></TableCell>
          <TableCell align="right"><h4>Total Cases</h4></TableCell>
          <TableCell align="right"><h4>Discharge</h4></TableCell>
          <TableCell align="right"><h4>Total Deaths</h4></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
        {renderTable()}
        </TableBody>
      </Table>
    </TableContainer>
        
        </div>
    )
}

export default Regional
